// extracted by mini-css-extract-plugin
export default {"btBlue":"QueueSystem_btBlue__7dIoJ","btGray":"QueueSystem_btGray__2gu5n","history":"QueueSystem_history__I+KJr"};